/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useRef, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { InfoWhiteIcon } from '../assets/svg/MasterCardIcons';
import {
  maskEmailID,
  maskMobileNumber,
  preferencesUserRequest,
  RootState,
  useSecureDeviceId,
  maskPhoneNumber,
  generateCodeForDeviceRequest,
  encryptAES,
  decryptAES,
  getChannelId,
} from '@rb-serve-app/core';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from './Spinner';
import VerificationCodeModal from './VerificationCodeModel';
import { useNavigate } from 'react-router-dom';
import { useRecaptchaToken, environment } from '@rb-serve-app/core';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import InlineError from './ErrorComponents/InlineError';
import { title } from 'process';
import SuccessModel from './SuccessModel';

interface VerifyIdentityModalProps {
  userData: any;
  currentModal: string | null;
  setIscoorpUserModal: any;
  coorpUser: boolean;
}

const VerifyIdentityModal: React.FC<VerifyIdentityModalProps> = ({
  userData,
  currentModal,
  setIscoorpUserModal,
  coorpUser,
}) => {
  const { handleSubmit, control, watch } = useForm({
    defaultValues: { contactMethod: '' },
  });

  interface GenerateForDevice {
    status: number;
    success: boolean;
  }
  const selectedPref = watch('contactMethod');
  const [currentModelToShow, setcurrentModelToShow] = useState(
    currentModal || null
  );
  const deviceId = useSecureDeviceId() || '';
  const [selectedMethod, setSelectedMethod] = useState(selectedPref || '');
  const [isPreferenceType, setIsPreferenceType] = useState<string | null>(null);
  const [isVerificationCodeModel, setisVerificationCodeModel] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );
  const { entries } = contentfulData;
  const getRecaptchaToken = useRecaptchaToken();
  const otpContentFullData = entries?.rb_otp_flow;
  const errorContent = otpContentFullData?.blockedUserPopupContent;
  const prefMethods = errorContent?.verification_method;
  console.log('verification_method', prefMethods);

  const dispatch = useDispatch();
  const { loading, preferencesUser, preferencesError } = useSelector(
    (state: RootState) => state.preferencesUser
  );

  const { isAuthenticated } = useSelector((state: RootState) => state?.user);
  const [error, setError] = useState<{
    title: string;
    description: string;
  } | null>(null);
  const [isPrefrenceApiError, setPrefrenceApiError] = useState(false);
  const { isGenerateCodeLoading, generateForDevice, isGenerateCodeError } =
    useSelector((state: RootState) => state.generateCode);
  const {
    isValidatePasscodeLoading,
    isValidatePasscodeError,
    validationPasscode,
  } = useSelector((state: RootState) => state.validatePasscode);

  useEffect(() => {
    setPrefrenceApiError(true);
  }, [preferencesError]);

  useEffect(() => {
    if (userData && deviceId !== '') {
      dispatch(
        preferencesUserRequest({
          username: userData?.data?.username,
          password: userData?.data?.password,
          deviceId: deviceId,
          channel: getChannelId,
          flow: 'PATH_PREF_API',
        })
      );
    }
  }, [userData, deviceId, dispatch]);

  useEffect(() => {
    if (selectedMethod) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [selectedMethod]);

  useEffect(() => {
    if ((generateForDevice as GenerateForDevice)?.status === 200) {
      setisVerificationCodeModel(true);
      setcurrentModelToShow('VERIFICATION_CODE');
    }
  }, [generateForDevice]);

  const handleMethodChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    item: any
  ) => {
    setSelectedMethod(e.target.value);
    setIsPreferenceType(item?.type);
  };
 const lang = localStorage.getItem('language') == 'fr' ? 'fr' : 'en'
  const sendCode = async () => {
    const { accountId, customerId } = preferencesUser;
    if (isPreferenceType !== null) {
      const token = await getRecaptchaToken('generate_token');
      const generateData = {
        preferenceType: isPreferenceType,
        deviceId: deviceId,
        accountId: accountId,
        customerId: customerId,
        username: userData?.data?.username,
        password: userData?.data?.password,
        channel: getChannelId,
        flow: 'PATH_GEN_CODE_API',
        recaptchaToken: token,
      };
      dispatch(generateCodeForDeviceRequest(generateData));
    }
  };
  const navigate = useNavigate();
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (modalRef.current) {
      modalRef.current.focus();
    }
  }, [currentModelToShow]);

  if (preferencesUser?.productName === 'Rogers Corporate') {
    setIscoorpUserModal(true);
    return;
  }
  useEffect(() => {
    if (isGenerateCodeError?.status == '401') {
      setError({
        title:
          entries?.rb_error?.recaptchaErrors[isGenerateCodeError?.errorCode]
            ?.title,
        description:
          entries?.rb_error?.recaptchaErrors[isGenerateCodeError?.errorCode]
            ?.description,
      });
    } else {
      if (isGenerateCodeError) {
        setError({
          title: entries?.rb_error?.genericApiFailure?.text,
          description: entries?.rb_error?.genericApiFailure?.text,
        });
      }
    }
  }, [isGenerateCodeError]);

  const [sortedData, setSortedData] = useState<any[]>([]);

  useEffect(() => {
    if (preferencesUser?.preferences) {
      const desiredOrder = [
        'EMAIL',
        'ALTERNATE_1',
        'HOME',
        'BUSINESS',
        'ALTERNATE_2',
      ];

      const sorted = [...preferencesUser.preferences].sort(
        (a: any, b: any) =>
          desiredOrder.indexOf(a.type) - desiredOrder.indexOf(b.type)
      );

      setSortedData(sorted);
    }
  }, [preferencesUser]);

  const handelSuccessErrorClose = () => {
    setPrefrenceApiError(false);
  };

  if (preferencesError) {
    return (
      isPrefrenceApiError && (
        <SuccessModel
          isOpen={isPrefrenceApiError}
          title={entries?.rb_error?.genericApiFailure?.header}
          subTitle={entries?.rb_error?.genericApiFailure?.text}
          successIcon={false}
          closeModal={handelSuccessErrorClose}
          errorIcon={false}
        />
      )
    );
  }

  return (
    <>
      {otpContentFullData ? (
        <div>
          {currentModelToShow == 'VERIFY_IDENTITY' && (
            <GoogleReCaptchaProvider
              reCaptchaKey={environment.recaptchaSiteKey}
               language={lang}
              container={{
                parameters: {
                  badge: 'bottomright',
                  theme: 'light',
                },
              }}
              scriptProps={{ async: true, defer: true }}
            >
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 min-h-screen ">
                {preferencesUser?.preferences?.length > 0 ? (
                  <>
                    <div className="flex items-center justify-center md:p-4 p-0 md:max-h-[80vh] md:h-[80vh] max-h-full h-full w-full md:w-[60%]">
                      <div
                        className="xl:w-[100%] lg:w-[100%] md:w-[100%] sm:w-full md:max-h-[70vh] md:h-[70vh] max-h-full h-full overflow-y-auto bg-white md:rounded-[15px] rounded-none shadow-lg"
                        ref={modalRef}
                        tabIndex={-1}
                        role="dialog"
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                      >
                        <div className="px-[30px] py-11 flex flex-col justify-center items-center">
                          <h2
                            id="modal-title"
                            className="text-left md:text-center xl:text-[28px] text-[16px] md:font-[400] font-[600] md:leading-[34px] leading-none"
                          >
                            {otpContentFullData?.idSelectContactMethod}
                          </h2>
                          <p
                            id="modal-description"
                            className="text-left md:text-center xl:text-[20px] text-[15px] font-normal md:leading-[25px] leading-tight mt-[10px]"
                          >
                            {otpContentFullData?.idAccountLockedTitle}
                          </p>

                          {error && (
                            <div className="mt-5 w-full">
                              <InlineError
                                errorText={error?.description}
                                aria-live="assertive"
                                fontSize={'text-[15px]'}
                                onClose={() => setError(null)}
                                oncloseHide={true}
                              />
                            </div>
                          )}
                          <div className="model-body flex flex-col xl:w-[68%] lg:w-full justify-center items-center">
                            <form
                              onSubmit={handleSubmit(sendCode)}
                              className="space-y-4 mt-6"
                              aria-labelledby="contact-methods"
                            >
                              <div
                                id="contact-methods"
                                role="radiogroup"
                                aria-labelledby="modal-title"
                                className="flex justify-start items-start flex-col"
                              >
                                {(sortedData ?? []).map(
                                  (item: any, index: number) => (
                                    <div
                                      key={item?.value}
                                      className="flex items-center justify-start gap-[10px] px-5 py-4 self-stretch border border-[#E9E9E9] bg-white"
                                    >
                                      <Controller
                                        name="contactMethod"
                                        control={control}
                                        render={({ field }) => (
                                          <input
                                            {...field}
                                            type="radio"
                                            id={item?.value}
                                            value={item?.value}
                                            onChange={(e) =>
                                              handleMethodChange(e, item)
                                            }
                                            className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 accent-[#DA291C]"
                                          />
                                        )}
                                      />
                                      <div
                                        className={`${item?.type !== 'EMAIL' && 'flex flex-col gap-0'}`}
                                      >
                                        {item?.type !== 'EMAIL' && (
                                          <span className="ml-2 text-[12px] font-[400] text-gray-800">
                                            {
                                              prefMethods[
                                                item?.type?.toLowerCase()
                                              ]
                                            }
                                          </span>
                                        )}
                                        <label
                                          htmlFor={item?.value}
                                          className="ml-2 text-[16px] font-[400] text-gray-800"
                                        >
                                          {item?.type === 'EMAIL'
                                            ? maskEmailID(
                                                decryptAES(item?.value)
                                              )
                                            : maskPhoneNumber(
                                                decryptAES(item?.value)
                                              )}
                                        </label>
                                      </div>
                                    </div>
                                  )
                                )}
                                {/* <div className="px-[20px] py-[20px] border border-[#E9E9E9] bg-gray-50 flex flex-row gap-[12px]">
                                <div className="w-[3%] mt-[2px]">
                                  <InfoWhiteIcon
                                    fill="#DA291C"
                                    width="24"
                                    height="24"
                                  />
                                </div>
                                <p className="text-[16px] font-[400] leading-[20px] text-black w-[97%]">
                                  {errorContent?.verification_code_content}
                                </p>
                              </div> */}
                              </div>

                              <div
                                className="flex justify-center items-center gap-[20px] mt-[30px] md:relative md:bottom-0 fixed bottom-[30px] md:z-0 z-[999] right-[30px] left-[30px] md:left-0 md:right-0"
                                style={{ marginTop: '30px' }}
                              >
                                <button
                                  aria-label={
                                    otpContentFullData?.deviceNotRecogonizedPopupCtaSecondaryTitle
                                  }
                                  type="button"
                                  onClick={() => navigate(0)}
                                  className="p-[12px] text-text16 font-[600] bg-white hover:bg-red-50 text-primary-red focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 border border-primary-red w-[160px] h-[48px]"
                                >
                                  {
                                    otpContentFullData?.deviceNotRecogonizedPopupCtaSecondaryTitle
                                  }
                                </button>
                                <div className="relative w-[160px]">
                                  <button
                                    aria-label={
                                      otpContentFullData?.identityVerificationContactMethodCtaPrimary
                                    }
                                    type="submit"
                                    onClick={() => console.log('')}
                                    disabled={
                                      isDisabled || isGenerateCodeLoading
                                    }
                                    className={`${isDisabled && !isGenerateCodeLoading ? 'bg-disabled-bg-color text-Text-disabled-btn border-[#D9D9D9] border min-h-[48px]' : 'bg-[#DA291C] hover:bg-red-700 text-white focus:ring-red-500'}  w-[160px] h-[48px] font-medium py-2 px-4 focus:outline-none focus:ring-2 focus:ring-opacity-50"`}
                                    onKeyDown={(e) =>
                                      e.key === 'Enter' &&
                                      !isDisabled &&
                                      !isGenerateCodeLoading &&
                                      sendCode()
                                    }
                                  >
                                    {isGenerateCodeLoading
                                      ? ''
                                      : otpContentFullData?.identityVerificationContactMethodCtaPrimary}
                                  </button>
                                  {isGenerateCodeLoading && (
                                    <div className="flex justify-center items-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                                      <div className="animate-spin ease-linear rounded-full border-4 border-t-4 border-white h-6 w-6"></div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                        {/* {isVerificationCodeModel&& isPreferenceType && <VerificationCodeModal selectedMethod={selectedMethod} isPreferenceType={isPreferenceType}  userData={userData}/>} */}
                      </div>
                    </div>
                    <div className="block md:hidden fixed bottom-0 left-0 w-full h-[12%] bg-[#FAFAFA] border-t border-[#E9E9E9]"></div>
                  </>
                ) : (
                  <Spinner />
                )}
              </div>
            </GoogleReCaptchaProvider>
          )}
          {currentModelToShow == 'VERIFICATION_CODE' && (
            <>
              {isVerificationCodeModel && isPreferenceType && (
                <GoogleReCaptchaProvider
                  reCaptchaKey={environment.recaptchaSiteKey}
                   language={lang}
                  container={{
                    parameters: {
                      badge: 'bottomright',
                      theme: 'light',
                    },
                  }}
                  scriptProps={{ async: true, defer: true }}
                >
                  <VerificationCodeModal
                    selectedMethod={selectedMethod}
                    isPreferenceType={isPreferenceType}
                    userData={userData}
                    setcurrentModelToShow={setcurrentModelToShow}
                  />
                </GoogleReCaptchaProvider>
              )}
            </>
          )}
        </div>
      ) : (
        <div className="flex justify-center items-center h-[80vh]">
          <Spinner />
        </div>
      )}
    </>
  );
};

export default VerifyIdentityModal;
